import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { TokenInput, SelectIncludeExclude, Checkbox } from 'components/common';
import { setFilter } from 'actions/calendar';
import { getFilter } from 'selectors/calendar';

const components = {
  checkbox: ({ value, ...rest }) => <Checkbox {...rest} checked={value} />,
  token: TokenInput,
  selectIncludeExclude: SelectIncludeExclude,
};

const FilterField = React.forwardRef(
  (
    {
      filterId,
      filterType,
      onChange,
      allowClear = true,
      overrideValue,
      ...rest
    },
    ref
  ) => {
    const Component = components[filterType];

    const value = useSelector(getFilter(filterId));
    const dispatch = useDispatch();

    const handleChange = value => {
      if (onChange) return onChange(value);
      dispatch(setFilter(filterId, value));
    };

    return (
      <Component
        {...rest}
        data-testid={`filter-${filterId}`}
        onChange={handleChange}
        value={overrideValue ? overrideValue : value}
        allowClear={allowClear}
      />
    );
  }
);

export default FilterField;
